import {FC} from 'react';
import classNames from 'classnames';
import {
  MAX_INTERVAL_COUNT,
  PERCENT_RATE
} from '../../../constants/timeProgressBar';
import {getIntervalsParams} from './helpers/getIntervalsParams';

type IntervalsProps = {
  currentTime: number,
  max: number,
}

const Intervals: FC<IntervalsProps> = ({
  max,
  currentTime
}) => {
  const {
    intervals,
    activeIntervalWidth,
    formattedTime
  } = getIntervalsParams(currentTime, max);

  if (!intervals.length) {
    return null;
  }

  return (
    <>
      {intervals.map((interval, index) => {
        const isActive = index === intervals.length - 1;
        const isLastAvailableInterval = index === MAX_INTERVAL_COUNT;
        const width = !isActive ? PERCENT_RATE : activeIntervalWidth;
        const isTimerVisible = isActive && activeIntervalWidth < PERCENT_RATE;

        return (
          <div key={`${index}${width}`} className={classNames('interval__wrapper', {
            'active': isActive,
            'last': isLastAvailableInterval
          })}>
            <div className="interval__value" style={{width: `${width}%`}} />
            {isTimerVisible && <div className="interval__timer">{formattedTime}</div>}
          </div>
        );
      })}
    </>
  );
};

export default Intervals;
